'use strict';

class CloudService {
  constructor(apiClient) {
    this.api = apiClient;
  }

  initialize() { return true; }

  async getPlayerProfile() {
    const payload = await this.api.progress();
    return payload.progress;
  }

  getCurrentConfig() { return this.api.currentConfig(); }
  startRun(level, clientVersion) {
    return this.api.startRun({ level, clientVersion });
  }
  finishRun(runId, payload) { return this.api.finishRun(runId, payload); }
  abandonRun(runId) { return this.api.abandonRun(runId); }
  dashboard() { return this.api.dashboard(); }
  leaderboard(type, period, limit) { return this.api.leaderboard(type, period, limit); }
  cosmetics() { return this.api.cosmetics(); }
  selectCosmetic(type, key) { return this.api.selectCosmetic({ type, key }); }
}

module.exports = CloudService;
